if (DESKTOP) {
    var $popularMaterialsSlider = $('#popular-materials-slider');

    if ($popularMaterialsSlider.length) {
        var query = {};
        query['popular_ids'] = $popularMaterialsSlider.data('popular-ids')
        $.get($popularMaterialsSlider.data('url'), query, function (data) {
            $popularMaterialsSlider.append(data.template);
            $popularMaterialsSlider.data('popular_ids', data.options.popularIds)
            $popularMaterialsSlider
                .on('init', function (event, slick) {
                    $(event.target).removeClass('is-cropped');
                    slick.$dots.appendTo('#popular-materials-header');
                })
                .slick({
                    adaptiveHeight: true,
                    arrows: false,
                    dots: true,
                    infinite: false,
                    speed: 200,
                    customPaging: function (slider, i) {
                        var index = $(slider.$slides[i]).data('slick-index') + 1;
                        return '<a href="#">' + index + '</a>';
                    }
                });
        });

    }
}